<script lang="ts">
    import Tab from "@apps/iloom_customization/components/Tab.svelte";
    import Tabs from "@apps/iloom_customization/components/Tabs.svelte";
    import { SPACE_TAB_LIST_ATTRIBUTES } from "@apps/iloom_customization/constants/constants";

    import type TabsManager from "@components/Tabs/TabsManager";

    export let tabsManager: TabsManager;

    const tabs = SPACE_TAB_LIST_ATTRIBUTES;

    const openedTab$ = tabsManager.openedTab$;

    const onClick = (value: string) => {
        tabsManager.openTab(value);
    };
</script>

<Tabs class="gw-crv-page__space-tabs">
    {#each tabs as tab}
        <Tab
            class="gw-crv-page__space-tab"
            openedTab={$openedTab$}
            variant="squared"
            {tab}
            {onClick}
        />
    {/each}
</Tabs>

<style lang="postcss">
    :global(.gw-tabs.gw-crv-page__space-tabs) {
        margin-bottom: 40px;
    }

    :global(.gw-tab.gw-crv-page__space-tab) {
        flex: 1;
    }

    @media all and (max-width: 600px) {
        :global(.gw-tabs.gw-crv-page__space-tabs) {
            margin-bottom: 24px;
            margin-left: calc(var(--container-gutter, 16px) * -1);
            margin-right: calc(var(--container-gutter, 16px) * -1);
        }

        :global(.gw-tab.gw-crv-page__space-tab) {
            min-width: 116px;
            font-size: 12px;
        }
    }
</style>
